module.exports = __webpack_public_path__ + "static/img/is_need_smt_tips.cd7ce4f4.png";